import http from '@/axios/http'
//获取port
export function getRemoteLink(did) {
    const data = {
        did: did
    }
    return http({
        url: '/api/device/sendRemote',
        method: 'post',
        data
    })
}
//跳转gateone
export function getRemoteLinks(did) {
    const data = {
        did: did
    }
    return http({
        url: '/api/device/getRemoteLink',
        method: 'post',
        data
    })
}
//关闭代理
export function closeRemote(did) {
    const data = {
        did: did
    }
    return http({
        url: '/api/device/closeRemote',
        method: 'post',
        data
    })
}